import React from 'react';
import { useSelector } from 'react-redux';
import RenderTotalAmount from './RenderTotalAmount';
import RenderCartCourses from './RenderCartCourses';

function Cart(props) {

    const {total, totalItems} = useSelector((state) => state.cart)

    return (
        <div className='text-richblack-25'>
            <h1 className='text-3xl'>Your Cart</h1>
            <div>
                <p>Courses in cart {totalItems}</p>
                <hr className='text-richblack-500 mt-4'/>
            </div>

            {
                total > 0 ? (<div className='flex max-[450px]:flex-col w-full'>
                    <div className='w-[80%] max-[450px]:w-[100%]'>
                        <RenderCartCourses/>
                    </div>
                    <RenderTotalAmount/>
                </div>) : (<div>Your Cart is empty</div>)
            }

        </div>
    );
}

export default Cart;